<template>
    <div class="search">
        <Search></Search>
    </div>
</template>

<script>
import Search from '../components/search/Search';

export default {
    name: 'search',
    components: {
        Search,
    },
};
</script>

<style lang="less" scoped>
</style>